/**
 * Team daily reports (`dayTeam.*`), merged into the dictionary through `extra.ts`.
 * `dayTeamEn` is typed against `dayTeamPl`, so a missing key is a compile error.
 */
export const dayTeamPl = {
  nav: 'Raporty dzienne',
  title: 'Raporty dzienne zespołu',
  subtitle: 'Aktywność handlowców dzień po dniu: wizyty, kontakty, zadania, sprzedaż i komentarze do raportu.',
  span: { day: 'Dzień', week: 'Tydzień' },
  prev: 'Poprzedni',
  next: 'Następny',
  today: 'Dziś',
  range: '{from} – {to}',
  sort: { label: 'Sortuj', name: 'Nazwisko', sales: 'Sprzedaż', visits: 'Wizyty' },
  loadError: 'Nie udało się wczytać raportów',
  empty: { title: 'Brak handlowców w Twoim zakresie', body: 'Raporty dzienne dotyczą użytkowników z rolą handlowca, których widzisz w swoim zakresie danych.' },
  stats: {
    visits: 'Wizyty',
    visitsHint: 'z {planned} planowanych',
    contacts: 'Kontakty',
    sales: 'Sprzedaż',
    salesHint: 'marża {margin}',
    overdue: 'Zaległe zadania',
    overdueHint: 'łącznie w zespole',
    reports: 'Komentarze',
    reportsHint: 'handlowców z komentarzem',
  },
  insight: {
    quiet: 'Nikt z zespołu nie zapisał jeszcze aktywności w tym okresie.',
    missing: 'Brak komentarza do raportu: {count} z {total} handlowców.',
    allIn: 'Wszyscy handlowcy uzupełnili komentarz do raportu.',
    overdue: 'Zaległych zadań w zespole: {count}.',
  },
  row: {
    visits: 'Wizyty',
    contacts: 'Kontakty',
    tasks: 'Zadania',
    sales: 'Sprzedaż',
    orders: 'Zamówienia',
    overdue: 'Zaległe',
    noComment: 'Brak komentarza',
    commented: 'Komentarz',
    commentDays: 'Komentarze: {count}',
    showComment: 'Pokaż komentarz',
    hideComment: 'Ukryj komentarz',
  },
};

export const dayTeamEn: typeof dayTeamPl = {
  nav: 'Daily reports',
  title: 'Team daily reports',
  subtitle: 'Sales rep activity day by day: visits, contacts, tasks, sales and report comments.',
  span: { day: 'Day', week: 'Week' },
  prev: 'Previous',
  next: 'Next',
  today: 'Today',
  range: '{from} – {to}',
  sort: { label: 'Sort', name: 'Name', sales: 'Sales', visits: 'Visits' },
  loadError: 'Could not load the reports',
  empty: { title: 'No sales reps in your scope', body: 'Daily reports cover users with the sales rep role that you can see in your data scope.' },
  stats: {
    visits: 'Visits',
    visitsHint: 'of {planned} planned',
    contacts: 'Contacts',
    sales: 'Sales',
    salesHint: 'margin {margin}',
    overdue: 'Overdue tasks',
    overdueHint: 'across the team',
    reports: 'Comments',
    reportsHint: 'reps with a comment',
  },
  insight: {
    quiet: 'Nobody on the team has logged any activity in this period yet.',
    missing: 'No report comment from {count} of {total} reps.',
    allIn: 'All reps have filled in their report comment.',
    overdue: 'Overdue tasks across the team: {count}.',
  },
  row: {
    visits: 'Visits',
    contacts: 'Contacts',
    tasks: 'Tasks',
    sales: 'Sales',
    orders: 'Orders',
    overdue: 'Overdue',
    noComment: 'No comment',
    commented: 'Comment',
    commentDays: 'Comments: {count}',
    showComment: 'Show comment',
    hideComment: 'Hide comment',
  },
};
